import { useMemo } from "react";
import qs from "query-string";

function getStorageKey() {
  if (!window.name) {
    window.name = `tab_${Date.now()}_${Math.random().toString(36).slice(2)}`;
  }
  return `__persistent_query__${window.name}`;
}

export function usePersistentQuery<
  T extends Record<string, any> = Record<string, any>,
>(): T {
  return useMemo(() => {
    const { search } = window.location;
    const key = getStorageKey();

    if (search) {
      const parsed = qs.parse(search);
      try {
        localStorage.setItem(key, JSON.stringify(parsed));
      } catch (error) {
        console.log(
          "[usePersistentQuery] Failed to save query to localStorage:",
          error,
        );
      }

      return parsed as T;
    }

    const saved = localStorage.getItem(key);
    if (saved) {
      try {
        return JSON.parse(saved) as T;
      } catch {
        return {} as T;
      }
    }

    return {} as T;
  }, []);
}
